import { clsx, type ClassValue } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

/**
 * La scala tipografica del progetto è semantica (`text-label`, `text-title`, …)
 * e tailwind-merge non la conosce: senza questa estensione confonderebbe un
 * corpo con un colore e ne scarterebbe uno dei due quando un componente riceve
 * una `className` che sovrascrive il default.
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [
        {
          text: ['mono-xs', 'label', 'meta', 'sm', 'base', 'lead', 'title', 'display', 'hero'],
        },
      ],
    },
  },
})

/** Compone classi condizionali risolvendo i conflitti fra utility Tailwind. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
